import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/FTP/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import FTPTable from 'components/Web_User_Interface/1440p_Series/Features/FTP/ftpTable';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Features/FTP/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  FTPTable,
  PrimaryBox,
  BreadCrumbs,
  SEOHelmet,
  React
};